<template>
  <div ref="container" class="container-theme"></div>
</template>

<script>
import moment from "moment";
import imageKrathong1 from "@/assets/theme/loy-krathong/no-1.svg";
import imageKrathong2 from "@/assets/theme/loy-krathong/no-2.svg";
import imageKrathong3 from "@/assets/theme/loy-krathong/no-3.svg";
import imageKrathong4 from "@/assets/theme/loy-krathong/no-4.svg";

export default {
  mounted() {
    const dtn = moment();
    const currentYear = dtn.month() < 1 ? dtn.year() - 1 : dtn.year();
    const startDate = moment()
      .year(currentYear)
      .month(10)
      .date(1)
      .startOf("day");
    const endDate = moment()
      .year(currentYear + 1)
      .month(0)
      .date(31)
      .endOf("day");
    console.log(startDate, endDate);

    // if (dtn.isBetween(startDate, endDate, undefined, "[]") || true) {
    const body = this.$refs.container;

    const sleep = async (msec) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(true);
        }, msec);
      });
    };
    const createKrathong = async () => {
      const minSec = 1000;
      const maxSec = 2000;
      const randomTime =
        Math.floor(Math.random() * (maxSec - minSec + 1)) + minSec;
      await sleep(randomTime);
      const element = document.createElement("div");
      element.classList.add("krathong");
      element.style.animationDuration = `${Math.random() * 3 + 24}s`; // ความเร็ว
      const image = document.createElement("img");
      image.width = 64;
      image.style.objectFit = "contain";
      const randomNumber = Math.floor(Math.random() * 4) + 1;
      switch (randomNumber) {
        case 1:
          image.src = imageKrathong1;
          break;
        case 2:
          image.src = imageKrathong2;
          break;
        case 3:
          image.src = imageKrathong3;
          break;
        case 4:
          image.src = imageKrathong4;
          break;
      }
      element.appendChild(image);
      body.appendChild(element);

      setTimeout(() => {
        image.remove();
        element.remove();
      }, 100000);
    };
    setInterval(createKrathong, 5000);
    // }
  },
};
</script>

<style scoped>
.container-theme {
  position: fixed;
  bottom: 70px;
  left: 0px;
  z-index: 9999;
  width: 100vw;
  height: 1px;
  background-color: transparent;
  display: flex;
  align-items: center;
}
</style>
<style>
.krathong {
  position: absolute;
  width: 64px;
  animation: krathong_float 1s linear infinite,
    krathong_sway 1s ease-in-out infinite;
  pointer-events: none;
}

@keyframes krathong_float {
  0% {
    left: -60px;
  }
  100% {
    left: 100vw;
  }
}

@keyframes krathong_sway {
  0% {
    transform: rotate(0);
    margin-top: 0px;
    margin-bottom: 0px;
  }
  20% {
    transform: rotate(8deg);
    margin-top: 8px;
    margin-bottom: 0px;
  }
  40% {
    transform: rotate(-8deg);
    margin-top: 0px;
    margin-bottom: 8px;
  }
  60% {
    transform: rotate(8deg);
    margin-top: 8px;
    margin-bottom: 0px;
  }
  80% {
    transform: rotate(-8deg);
    margin-top: 0px;
    margin-bottom: 8px;
  }
  100% {
    transform: rotate(0);
    margin-top: 0px;
    margin-bottom: 0px;
  }
}
</style>